import Mutations from '../../odata/mutations';

export default { ...new Mutations('csvOrder'), ...new Mutations('csvOrders') };
